import { render, staticRenderFns } from "./OptionsChoice.vue?vue&type=template&id=3baf0ecd&scoped=true&"
import script from "./OptionsChoice.vue?vue&type=script&lang=js&"
export * from "./OptionsChoice.vue?vue&type=script&lang=js&"
import style0 from "./OptionsChoice.vue?vue&type=style&index=0&id=3baf0ecd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf0ecd",
  null
  
)

export default component.exports